import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { Box } from '@honda-canada/design-system-react';
import { videoTypes } from '../../utils/constants';

const configControls = {
  [videoTypes.youtube]: {
    playerVars: {
      autoplay: 0,
      controls: 1,
    },
  },
  [videoTypes.vimeo]: {
    playerOptions: {
      autopause: true,
      byline: false,
      controls: true,
    },
  },
};

const VideoModalPlayer = ({ source, videoType, responsive, ...styleProps }) => {
  const playerRef = useRef(null);

  let containerStyles = {};
  let iframeInlineStyles = {};

  if (responsive) {
    containerStyles = {
      padding: '56.25% 0 0 0',
    };

    iframeInlineStyles = {
      top: videoType === videoTypes.vimeo ? 0 : 60,
      left: 0,
      width: '100%',
      height: '100%',
      position: 'absolute',
    };
  }

  return (
    <Box {...styleProps} style={containerStyles}>
      <ReactPlayer
        data-testid="cy-video-player"
        ref={playerRef}
        url={source}
        style={iframeInlineStyles}
        width="100%"
        height={videoType === videoTypes.vimeo ? '100%' : '90%'}
        playing={false}
        controls
        config={configControls[videoType]}
      />
    </Box>
  );
};

VideoModalPlayer.propTypes = {
  source: PropTypes.string.isRequired,
  responsive: PropTypes.bool,
  videoType: PropTypes.string.isRequired,
};

VideoModalPlayer.defaultProps = {
  responsive: false,
};

export default VideoModalPlayer;
